import { useListHoldings, useListOrders } from '@/trading/tradingQueries'

export const usePreloadPortfolio = (enabled: boolean, params: any) => {
    useListHoldings({ enabled })
    useListOrders({ enabled, ...params })
}
